'use strict';

angular.module('cgmemApp')
  .factory('Sysvars', function ($http, $q, $log, AppConfig) {
    var api = {};
		var sysvars = [];
		
		api.load = function() {
			return $http.get('/api/sysvars')	// needs to be fixed
			.then(function(data) {
				sysvars = data.data;
				return sysvars;
			});
		}

		api.getVal = function(id, path) {
			if(!id)	return sysvars;
			var t = _.find(sysvars, { _id: id });
    	return (t ? t.get('val'+(path ? '.'+path : '')) : null);
		}
		
		api.upsert = function(s) {
			return $http.put('/api/sysvars/'+s._id, s)
			.then(function(data) {
				// Reload appconfig
				//AppConfig.load();
				return data.data;
			});
		}			
		
		return api;
  });